export function scrollToLatestContent(container) {
  if (!container) return;
  container.scrollTop = container.scrollHeight;
}
